import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function Girls({ ladies }) {
    const navigate = useNavigate();

    return (
        <div>
            <PageHeader title="OUR GIRLS" />
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                    {ladies.map((lady, index) => (
                        <div
                            key={index}
                            className="overflow-hidden text-center cursor-pointer"
                            onClick={() => navigate(`/ladies/${lady.name.toLowerCase()}`)}
                        >
                            <div className="aspect-[221/340] relative overflow-hidden">
                                <img
                                    src={lady.images?.length >= 1 ? lady.images[0] : ""} // Use first image as main image
                                    alt={lady.name}
                                    className="absolute inset-0 w-full h-full object-contain transition-transform duration-300 hover:scale-110"
                                />
                            </div>
                            <div className="p-6">
                                <h2 className="text-md mb-4 text-pink-700">{lady.name}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Girls;